import type { AuthSession, SaveDocument } from '../api'
import type { GameState } from '../game'
export type { CloudStatus, Panel, Preferences, SaveSelection, VipStatus } from '../view-types'
import type { CloudStatus, Panel, Preferences, SaveSelection } from '../view-types'

export type PanelDialogProps = {
  panel: Exclude<Panel, null>
  state: GameState | null
  locationLabel: string
  preferences: Preferences
  authSession: AuthSession | null
  authLoading: boolean
  authError: string
  cloudStatus: CloudStatus
  cloudDocument: SaveDocument | null
  saveSelection: SaveSelection | null
  cloudError: string
  cloudActionError: string
  cloudActionBusy: boolean
  onClose: () => void
  onPreferences: (value: Preferences) => void
  onReset: () => void
  onLogin: () => void
  onLogout: () => void
  onSync: () => void
  onChooseGuest: () => void
  onChooseCloud: () => void
  onRefreshAuth: () => void
  onResetCloud: (scope: 'run' | 'all') => void
}

export function cloudStatusText(status: CloudStatus): string {
  return {
    idle: '等待账号同步',
    loading: '正在读取云存档…',
    synced: '云存档已确认',
    pending: '正在同步…',
    offline: '云存档暂时不可用',
    choosing: '等待选择存档'
  }[status]
}
